import { ComposeArea } from '@threema/compose-area';
import { isActionTrigger } from '../helpers';
import { parseEmoji, shortnameToUtf8 } from '../helpers/emoji';
import { isEmojiInfo, isKeyboardEvent } from '../typeguards';
export default [
    'BrowserService',
    'LogService',
    'StringService',
    'TimeoutService',
    'ReceiverService',
    'SettingsService',
    '$timeout',
    '$translate',
    '$mdDialog',
    '$filter',
    '$rootScope',
    function (browserService, logService, stringService, timeoutService, receiverService, settingsService, $timeout, $translate, $mdDialog, $filter, $rootScope) {
        const log = logService.getLogger('ComposeArea-C');
        return {
            restrict: 'EA',
            scope: {
                onInit: '=',
                submit: '=',
                startTyping: '=',
                stopTyping: '=',
                onTyping: '=',
                onKeyDown: '=',
                initialData: '=',
                onUploading: '=',
                maxTextLength: '=',
                receiver: '<receiver',
            },
            link: function (scope, wrapper) {
                const TRIGGER_ENABLED_CSS_CLASS = 'is-enabled';
                const TRIGGER_ACTIVE_CSS_CLASS = 'is-active';
                const select = (selector) => angular.element(wrapper[0].querySelector(selector));
                const composeDiv = select('div.compose');
                const emojiTrigger = select('i.emoji-trigger');
                const emojiKeyboard = select('.emoji-keyboard');
                const sendTrigger = select('i.send-trigger');
                const fileTrigger = select('i.file-trigger');
                const fileInput = select('input.file-input');
                const userConfig = window['UserConfig'];
                const composeArea = ComposeArea.bind_to(composeDiv[0], userConfig.COMPOSE_AREA_LOG_LEVEL);
                if (scope.onInit) {
                    scope.onInit(composeArea);
                }
                if (scope.initialData.initialText) {
                    composeDiv[0].innerText = scope.initialData.initialText;
                    scope.initialData.initialText = '';
                }
                else if (scope.initialData.draft !== undefined) {
                    composeDiv[0].innerText = scope.initialData.draft;
                }
                let chatBlocked = false;
                function setChatBlocked(blocked) {
                    chatBlocked = blocked;
                    log.debug('Receiver blocked:', blocked);
                    if (blocked) {
                        sendTrigger.removeClass(TRIGGER_ENABLED_CSS_CLASS);
                        emojiTrigger.removeClass(TRIGGER_ENABLED_CSS_CLASS);
                        fileTrigger.removeClass(TRIGGER_ENABLED_CSS_CLASS);
                        composeDiv.attr('contenteditable', 'false');
                        if (emojiKeyboard.hasClass('active')) {
                            hideEmojiPicker();
                        }
                    }
                    else {
                        if (composeAreaIsEmpty()) {
                            sendTrigger.removeClass(TRIGGER_ENABLED_CSS_CLASS);
                        }
                        else {
                            sendTrigger.addClass(TRIGGER_ENABLED_CSS_CLASS);
                        }
                        emojiTrigger.addClass(TRIGGER_ENABLED_CSS_CLASS);
                        fileTrigger.addClass(TRIGGER_ENABLED_CSS_CLASS);
                        composeDiv.attr('contenteditable', 'true');
                    }
                }
                setChatBlocked(receiverService.isBlocked(scope.receiver));
                scope.$watch((_scope) => receiverService.isBlocked(_scope.receiver), (isBlocked, wasBlocked) => {
                    if (isBlocked !== wasBlocked) {
                        setChatBlocked(isBlocked);
                    }
                });
                let stopTypingTimer = null;
                const unsubscribeListeners = [];
                let submitKey = settingsService.composeArea.getSubmitKey();
                const settingsChangedEventHandler = () => {
                    submitKey = settingsService.composeArea.getSubmitKey();
                };
                settingsService.settingsChangedEvent.attach(settingsChangedEventHandler);
                unsubscribeListeners.push(() => settingsService.settingsChangedEvent.detach(settingsChangedEventHandler));
                function stopTyping() {
                    if (stopTypingTimer !== null) {
                        timeoutService.cancel(stopTypingTimer);
                        stopTypingTimer = null;
                        scope.stopTyping();
                    }
                }
                function startTyping() {
                    if (stopTypingTimer === null) {
                        scope.startTyping();
                    }
                    else {
                        timeoutService.cancel(stopTypingTimer);
                    }
                    stopTypingTimer = timeoutService.register(stopTyping, 10000, true, 'stopTyping');
                }
                function composeAreaIsEmpty() {
                    return composeArea.get_text().length === 0;
                }
                function submitText() {
                    const text = composeArea.get_text().replace(/\r/g, '');
                    return new Promise((resolve, reject) => {
                        const submitTexts = (strings) => {
                            const messages = [];
                            for (const piece of strings) {
                                messages.push({
                                    text: piece,
                                });
                            }
                            scope.submit('text', messages)
                                .then(resolve)
                                .catch(reject);
                        };
                        const byteLength = (new TextEncoder().encode(text)).length;
                        const reducedMaxLength = scope.maxTextLength - 30;
                        if (byteLength > reducedMaxLength) {
                            const chunkSize = scope.maxTextLength * 0.85;
                            const pieces = stringService.byteChunk(text, chunkSize, 50);
                            const confirm = $mdDialog.confirm()
                                .title($translate.instant('messenger.MESSAGE_TOO_LONG_SPLIT_SUBJECT'))
                                .textContent($translate.instant('messenger.MESSAGE_TOO_LONG_SPLIT_BODY', {
                                max: scope.maxTextLength,
                                count: pieces.length,
                            }))
                                .ok($translate.instant('common.YES'))
                                .cancel($translate.instant('common.NO'));
                            $mdDialog.show(confirm).then(function () {
                                submitTexts(pieces);
                            }, () => {
                                reject();
                            });
                        }
                        else {
                            submitTexts([text]);
                        }
                    });
                }
                function sendText() {
                    if (!composeAreaIsEmpty()) {
                        submitText().then(() => {
                            composeArea.clear();
                            composeArea.focus();
                            stopTyping();
                            scope.onTyping('');
                            updateView();
                        }).catch(() => {
                            log.warn('Failed to submit text');
                        });
                        return true;
                    }
                    return false;
                }
                let isComposing = false;
                let compositionHasJustEnded = false;
                function onCompositionStart(ev) {
                    isComposing = true;
                }
                function onCompositionEnd(ev) {
                    isComposing = false;
                    compositionHasJustEnded = true;
                }
                function onKeyDown(ev) {
                    let submit = false;
                    switch (submitKey) {
                        case 1:
                            submit = ev.key === 'Enter' && ev.ctrlKey;
                            break;
                        case 0:
                        default:
                            submit = ev.key === 'Enter' && !ev.shiftKey;
                    }
                    if (submit) {
                        ev.preventDefault();
                    }
                    if (scope.onKeyDown && scope.onKeyDown(ev) !== true) {
                        ev.preventDefault();
                        return;
                    }
                    if (ev.isComposing || isComposing || compositionHasJustEnded) {
                        return;
                    }
                    if (ev.key === ':') {
                        const modified = onEmojiShortcodeKeyPressed(ev, ':', false);
                        if (modified) {
                            ev.preventDefault();
                            return;
                        }
                    }
                    $timeout(() => {
                        if (submit) {
                            if (sendText()) {
                                return;
                            }
                        }
                        updateView();
                    }, 0);
                }
                function onKeyUp(ev) {
                    compositionHasJustEnded = false;
                    const html = composeDiv[0].innerHTML.trim();
                    if (html === '<br>') {
                        composeDiv[0].innerText = '';
                    }
                    const text = composeArea.get_text(true);
                    if (text.trim().length === 0) {
                        stopTyping();
                        scope.onTyping('');
                    }
                    else {
                        startTyping();
                        scope.onTyping(text.trim());
                    }
                    updateView();
                }
                function fetchFileListContents(fileList) {
                    return new Promise((resolve) => {
                        const buffers = new Map();
                        const fileCounter = fileList.length;
                        const next = (file, res, error) => {
                            buffers.set(file, res);
                            if (buffers.size >= fileCounter) {
                                resolve(buffers);
                            }
                        };
                        for (let n = 0; n < fileCounter; n++) {
                            const reader = new FileReader();
                            const file = fileList.item(n);
                            reader.onload = function (ev) {
                                next(file, this.result, ev);
                            };
                            reader.onerror = function (ev) {
                                next(file, null, ev);
                            };
                            reader.onprogress = function (ev) {
                                if (ev.lengthComputable) {
                                    const progress = ((ev.loaded / ev.total) * 100);
                                    scope.onUploading(true, progress, 100 / fileCounter * n);
                                }
                            };
                            reader.readAsArrayBuffer(file);
                        }
                    });
                }
                function uploadFiles(fileList) {
                    scope.onUploading(true, 0, 0);
                    fetchFileListContents(fileList).then((data) => {
                        const fileMessages = [];
                        data.forEach((buffer, file) => {
                            const fileMessageData = {
                                name: file.name,
                                fileType: file.type,
                                size: file.size,
                                data: buffer,
                            };
                            if (browserService.getBrowser().isFirefox(false)) {
                                if (fileMessageData.name.endsWith('.ogg') && fileMessageData.fileType === 'video/ogg') {
                                    fileMessageData.fileType = 'audio/ogg';
                                }
                            }
                            fileMessages.push(fileMessageData);
                        });
                        scope
                            .submit('file', fileMessages)
                            .catch((e) => log.error('Could not send file:', e));
                        scope.onUploading(false);
                    }).catch((ev) => {
                        log.error('Could not load file:', ev.message);
                    });
                }
                function onPaste(ev) {
                    ev.preventDefault();
                    if (!ev.clipboardData) {
                        return;
                    }
                    const items = ev.clipboardData.items;
                    if (!items) {
                        return;
                    }
                    let fileIdx = null;
                    let textIdx = null;
                    for (let i = 0; i < items.length; i++) {
                        if (items[i].kind === 'file' && (items[i].type.indexOf('image/') !== -1 || items[i].type === 'application/x-moz-file')) {
                            fileIdx = i;
                        }
                        else if (items[i].kind === 'string' && items[i].type === 'text/plain') {
                            textIdx = i;
                        }
                    }
                    if (fileIdx !== null) {
                        const blob = items[fileIdx].getAsFile();
                        if (blob !== null) {
                            const reader = new FileReader();
                            reader.onload = function (progressEvent) {
                                const buffer = this.result;
                                let fileName;
                                if (blob.name) {
                                    fileName = blob.name;
                                }
                                else if (blob.type && blob.type.match(/^[^;]*\//) !== null) {
                                    const fileExt = blob.type.split(';')[0].split('/')[1];
                                    fileName = 'clipboard.' + fileExt;
                                }
                                else {
                                    log.warn('Pasted file has an invalid MIME type: "' + blob.type + '"');
                                    return;
                                }
                                const fileMessageData = {
                                    name: fileName,
                                    fileType: blob.type,
                                    size: blob.size,
                                    data: buffer,
                                };
                                scope
                                    .submit('file', [fileMessageData])
                                    .catch((msg) => log.error('Could not send file:', msg));
                            };
                            reader.readAsArrayBuffer(blob);
                        }
                        else {
                            log.error('Could not get item as a blob');
                        }
                    }
                    else if (textIdx !== null) {
                        const text = ev.clipboardData.getData('text/plain');
                        if (text) {
                            const tokens = parseEmoji(text);
                            for (const token of tokens) {
                                if (isEmojiInfo(token)) {
                                    insertEmoji(token);
                                }
                                else {
                                    composeArea.insert_text(token);
                                }
                            }
                            updateView();
                        }
                    }
                    else {
                        log.warn('Nothing pastable found we currently support.');
                    }
                }
                let regularPlaceholder = '';
                let dragoverPlaceholder = '';
                $translate('messenger.COMPOSE_MESSAGE').then((translated) => regularPlaceholder = translated);
                $translate('messenger.COMPOSE_MESSAGE_DRAGOVER').then((translated) => dragoverPlaceholder = translated);
                function showEmojiPicker() {
                    $timeout(() => {
                        const emojiPicker = wrapper[0].querySelector('div.twemoji-picker');
                        emojiKeyboard.addClass('active');
                        emojiKeyboard.attr('aria-expanded', 'true');
                        emojiTrigger.attr('aria-pressed', 'true');
                        emojiTrigger.addClass(TRIGGER_ACTIVE_CSS_CLASS);
                        const allEmoji = angular.element(emojiPicker.querySelectorAll('.content .em'));
                        const allEmojiTabs = angular.element(emojiPicker.querySelectorAll('.tab label img'));
                        const skinSelectors = angular.element(emojiPicker.querySelectorAll('.skins img'));
                        allEmoji.on('click', onEmojiChosen);
                        allEmoji.on('keydown', onEmojiChosen);
                        allEmojiTabs.on('keydown', onEmojiTabSelected);
                        skinSelectors.on('click', onSkintoneSelected);
                        skinSelectors.on('keydown', onSkintoneSelected);
                        composeArea.focus();
                    });
                }
                function hideEmojiPicker() {
                    const emojiPicker = wrapper[0].querySelector('div.twemoji-picker');
                    emojiKeyboard.removeClass('active');
                    emojiKeyboard.attr('aria-expanded', 'false');
                    emojiTrigger.attr('aria-pressed', 'false');
                    emojiTrigger.removeClass(TRIGGER_ACTIVE_CSS_CLASS);
                    const allEmoji = angular.element(emojiPicker.querySelectorAll('.content .em'));
                    const allEmojiTabs = angular.element(emojiPicker.querySelectorAll('.tab label img'));
                    allEmoji.off('click', onEmojiChosen);
                    allEmoji.off('keydown', onEmojiChosen);
                    allEmojiTabs.off('keydown', onEmojiTabSelected);
                }
                function onEmojiTrigger(ev) {
                    ev.stopPropagation();
                    if (chatBlocked) {
                        hideEmojiPicker();
                        return;
                    }
                    if (emojiKeyboard.hasClass('active')) {
                        hideEmojiPicker();
                    }
                    else {
                        showEmojiPicker();
                    }
                }
                function onEmojiChosen(ev) {
                    if (ev.type === 'click' || (isKeyboardEvent(ev) && isActionTrigger(ev))) {
                        ev.stopPropagation();
                        if (isKeyboardEvent(ev)) {
                            ev.preventDefault();
                        }
                        insertSingleEmojiString(ev.target.textContent);
                        updateView();
                    }
                }
                function onSkintoneSelected(ev) {
                    if (ev.type === 'click' || (isKeyboardEvent(ev) && isActionTrigger(ev))) {
                        ev.stopPropagation();
                        if (isKeyboardEvent(ev)) {
                            ev.preventDefault();
                        }
                        const tone = ev.target.getAttribute('data-tone');
                        log.debug(`Skintone selected: Tone ${tone}`);
                        const emojiPicker = wrapper[0].querySelector('div.twemoji-picker');
                        emojiPicker.setAttribute('data-skintone', tone);
                    }
                }
                function onEmojiTabSelected(ev) {
                    if (isActionTrigger(ev)) {
                        ev.target.parentElement.previousElementSibling.checked = true;
                    }
                }
                function insertSingleEmojiString(emojiString) {
                    const tokens = parseEmoji(emojiString);
                    if (tokens.length !== 1) {
                        throw new Error(`Emoji parsing failed: Expected 1 element, found ${tokens.length}`);
                    }
                    const emoji = tokens[0];
                    if (!isEmojiInfo(emoji)) {
                        throw new Error(`Emoji parsing failed: Returned text, not emoji info`);
                    }
                    insertEmoji(emoji);
                }
                function insertEmoji(emoji) {
                    const img = composeArea.insert_image(emoji.imgPath, emoji.emojiString, 'em');
                    img.setAttribute('data-c', emoji.codepoint);
                    img.draggable = false;
                    img.ondragstart = () => false;
                }
                function onEmojiShortcodeKeyPressed(ev, trigger, alreadyProcessed) {
                    const word = composeArea.get_word_at_caret();
                    if (word === undefined) {
                        return false;
                    }
                    let before = word.before();
                    const after = word.after();
                    if (!alreadyProcessed) {
                        before += trigger;
                    }
                    if (after.length === 0 && before.length > 2) {
                        if (before.startsWith(trigger) && before.endsWith(trigger)) {
                            const trimmed = before.substr(1, before.length - 2);
                            const unicodeEmoji = shortnameToUtf8(trimmed);
                            if (unicodeEmoji !== null) {
                                composeArea.select_word_at_caret();
                                composeArea.store_selection_range();
                                insertSingleEmojiString(unicodeEmoji);
                                return true;
                            }
                        }
                    }
                    return false;
                }
                function onFileTrigger(ev) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    if (chatBlocked) {
                        return;
                    }
                    const input = wrapper[0].querySelector('.file-input');
                    input.click();
                }
                function onSendTrigger(ev) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    if (chatBlocked) {
                        return;
                    }
                    return sendText();
                }
                function onFileSelected() {
                    uploadFiles(this.files);
                    fileInput.val('');
                }
                function updateView() {
                    if (composeAreaIsEmpty()) {
                        sendTrigger.removeClass(TRIGGER_ENABLED_CSS_CLASS);
                    }
                    else {
                        sendTrigger.addClass(TRIGGER_ENABLED_CSS_CLASS);
                    }
                }
                composeDiv.on('compositionstart', onCompositionStart);
                composeDiv.on('compositionend', onCompositionEnd);
                composeDiv.on('keydown', onKeyDown);
                composeDiv.on('keyup', onKeyUp);
                document.addEventListener('selectionchange', () => {
                    composeArea.store_selection_range();
                });
                composeDiv.on('paste', onPaste);
                emojiTrigger.on('click', onEmojiTrigger);
                emojiTrigger[0].addEventListener('keypress', (ev) => {
                    if (isActionTrigger(ev)) {
                        $rootScope.$apply(() => {
                            onEmojiTrigger(ev);
                        });
                    }
                });
                fileTrigger.on('click', onFileTrigger);
                fileTrigger[0].addEventListener('keypress', (ev) => {
                    if (isActionTrigger(ev)) {
                        $rootScope.$apply(() => {
                            onFileTrigger(ev);
                        });
                    }
                });
                fileInput.on('change', onFileSelected);
                sendTrigger.on('click', onSendTrigger);
                sendTrigger[0].addEventListener('keypress', (ev) => {
                    if (isActionTrigger(ev)) {
                        $rootScope.$apply(() => {
                            onSendTrigger(ev);
                        });
                    }
                });
                updateView();
                const stopTypingOnBlur = () => stopTyping();
                window.addEventListener('blur', stopTypingOnBlur);
                unsubscribeListeners.push(() => window.removeEventListener('blur', stopTypingOnBlur));
                unsubscribeListeners.push($rootScope.$on('onQuoted', (event, args) => {
                    composeArea.focus();
                }));
                scope.$on('$destroy', () => {
                    unsubscribeListeners.forEach((u) => u());
                    stopTyping();
                });
            },
            template: `
                <div>
                    <div>
                        <i class="md-primary emoji-trigger trigger is-enabled material-icons" role="button" aria-label="emoji" aria-pressed="false" tabindex="0">tag_faces</i>
                    </div>
                    <div>
                        <div
                            class="compose"
                            id="composeDiv"
                            contenteditable
                            autofocus
                            data-gramm="false"
                            translate
                            translate-attr-data-placeholder="messenger.COMPOSE_MESSAGE"
                            translate-attr-aria-label="messenger.COMPOSE_MESSAGE"
                            tabindex="0"
                        ></div>
                    </div>
                    <div>
                        <i class="md-primary send-trigger trigger material-icons" role="button" aria-label="send" tabindex="0">send</i>
                        <i class="md-primary file-trigger trigger is-enabled material-icons" role="button" aria-label="attach file" tabindex="0">attach_file</i>
                        <input class="file-input" type="file" style="visibility: hidden" multiple>
                    </div>
                </div>
                <div class="emoji-keyboard" aria-expanded="false">
                    <ng-include src="'partials/emoji-picker.html'" include-replace></ng-include>
                </div>
            `,
        };
    },
];
